import { CardDetailOverlay, Image, MediaCard } from '@mntn/select-components'
import { AspectRatio, cn, Skeleton, Text } from '@mntn/ui-components'

type CardSize = 'sm' | 'md' | 'lg' | 'xl'

interface ImageProps {
  src: string
  alt: string
}

const programCardVariants = {
  sm: 'w-20',
  md: 'w-32',
  lg: 'w-48',
  xl: 'w-52',
}

const PROGRAM_CARD_ASPECT_RATIO = 4 / 5

interface Props {
  imageProps: ImageProps
  size: CardSize
  networkName: string
  programName: string
  className?: string
}

export const ProgramCard = ({ imageProps, size, networkName, programName, className }: Props) => {
  return (
    <div className={cn(programCardVariants[size], className)}>
      <AspectRatio ratio={PROGRAM_CARD_ASPECT_RATIO}>
        <MediaCard
          isDraft={false}
          layout="portrait"
          media={<Image src={imageProps.src} alt={imageProps.alt} className="w-full h-full object-cover" />}
          footer={
            <CardDetailOverlay
              overlayComponent={
                <div className="inline-flex flex-col items-start justify-start w-full">
                  <Text variant="h6" className="truncate w-full text-header-inverse">
                    {networkName}
                  </Text>
                  <Text variant="base-xs" className=" truncate text-primary-inverse" data-testid="program-card-name">
                    {programName}
                  </Text>
                </div>
              }
            />
          }
        />
      </AspectRatio>
    </div>
  )
}

interface SkeletonProps {
  size: CardSize
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const ProgramCardSkeleton: React.FC<SkeletonProps> = ({ size }) => {
  return (
    <div className={cn(programCardVariants[size])}>
      <AspectRatio ratio={PROGRAM_CARD_ASPECT_RATIO}>
        <Skeleton className="bg-surface-bg w-full h-full" />
      </AspectRatio>
    </div>
  )
}
